<template>
    <!-- 操作表组件 -->
    <XTable ref="table" :columns="columnsFilter" :data-api="dataApi" :params="params" v-bind="$attrs" :paging="false">
        <template v-slot:operation="{ cellData, record }">
            <slot :cellData="cellData" :record="record"></slot>
        </template>
    </XTable>
</template>
<script>
export default {
    props: {
        columns: Array,
        dataApi: Function,
        type: String,
        params:Object
    },
    data() {
        return {
        }
    },
    computed: {
        columnsFilter() {
            let newcolumns = JSON.parse(JSON.stringify(this.columns))
            let opration ={
                title: '操作',
                dataIndex: 'operation',
                type: 'oprationColumn'
            }
            newcolumns.push(opration)
            return newcolumns;
        }
    },
    created() {},
    methods: {
    }
}
</script>
<style lang="less" scoped></style>
